export default __webpack_public_path__ + "static/video_processing_en-4bea88b1847cce43bd127a85d10ac6a1.png";